import script from "./Authenticated.vue?vue&type=script&setup=true&lang=js"
export * from "./Authenticated.vue?vue&type=script&setup=true&lang=js"

import "./Authenticated.vue?vue&type=style&index=0&id=4e0f3b58&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e0f3b58"]])

export default __exports__